import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Event } from "../api/contentful";
import { faCalendar, faClock } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { slugify } from "../utils/slugify";
type EventCardBodyProps = {
  event: Event;
};

const EventCardBody = ({ event }: EventCardBodyProps) => {
  const slug = slugify(event.eventName);
  return (
    <div className="event-body-container">
      <div className="event-title-wrapper">
        <h3 className="event-title header-ellipsis">{event.eventName}</h3>
      </div>
      <div className="event-details">
        <div className="event-time-and-date">
          <FontAwesomeIcon icon={faCalendar} />
          <p>
            <span className="bold">Date: </span>
            {new Date(event.eventStartTime).toLocaleString("sv-SE", {
              dateStyle: "medium",
            })}
          </p>
        </div>
        <div className="event-time-and-date">
          <FontAwesomeIcon icon={faClock} />
          <p>
            <span className="bold">Time: </span>
            {new Date(event.eventStartTime).toLocaleString("sv-SE", {
              timeStyle: "short",
            })}{" "}
            -{" "}
            {new Date(event.eventEndTime).toLocaleString("sv-SE", {
              timeStyle: "short",
            })}
          </p>
        </div>
      </div>
      <p>
        <span className="bold">Event type: </span>
        {event.eventTypes?.join(", ")}
      </p>

      <Link className="btn event-btn" to={`/events/${slug}`}>
        Go to event
      </Link>
    </div>
  );
};

export default EventCardBody;
